import { render, staticRenderFns } from "./menuItem.vue?vue&type=template&id=3d717337&scoped=true&"
import script from "./menuItem.vue?vue&type=script&lang=js&"
export * from "./menuItem.vue?vue&type=script&lang=js&"
import style0 from "./menuItem.vue?vue&type=style&index=0&id=3d717337&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d717337",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d717337')) {
      api.createRecord('3d717337', component.options)
    } else {
      api.reload('3d717337', component.options)
    }
    module.hot.accept("./menuItem.vue?vue&type=template&id=3d717337&scoped=true&", function () {
      api.rerender('3d717337', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/contextMenu/menuItem.vue"
export default component.exports